
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[id]",
      function () {
        return require("private-next-pages/articles/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[id]"])
      });
    }
  